import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import { hostPaths } from '@/utils/hostPaths';

interface CommunityHostManagementItemProps {
  variant: 'mobile' | 'desktop';
}

export function CommunityHostManagementItem({ variant }: CommunityHostManagementItemProps) {
  const navigate = useNavigate();

  if (variant === 'desktop') {
    return (
      <button
        type="button"
        onClick={() => navigate(hostPaths.hosts)}
        className="w-full p-3.5 rounded-2xl border border-gray-100 bg-[#F8FAFC] hover:bg-orange-50/50 hover:border-orange-200 transition-all flex items-center justify-between text-left cursor-pointer group"
      >
        <div>
          <h3 className="font-bold text-[#0E1726] text-sm group-hover:text-[#FC480D]">
            Host Management
          </h3>
          <p className="text-xs text-gray-400 font-medium mt-0.5">
            Player dengan akses kelola komunitas
          </p>
        </div>
        <Icon icon="ph:caret-right-bold" className="w-4 h-4 text-gray-400 group-hover:text-[#FC480D] transition-colors" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => navigate(hostPaths.hosts)}
      className="w-full p-4 flex items-center gap-3.5 text-left hover:bg-gray-50/80 active:bg-gray-100 transition-colors cursor-pointer"
    >
      <div className="w-10 h-10 rounded-2xl bg-orange-50/80 text-[#FC480D] flex items-center justify-center flex-shrink-0">
        <Icon icon="ph:users-three-bold" className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-extrabold text-[#0E1726] text-sm leading-tight">Host Management</h3>
        <p className="text-xs text-gray-400 font-medium mt-0.5">Player dengan akses kelola komunitas</p>
      </div>
      <Icon icon="ph:caret-right-bold" className="w-4 h-4 text-gray-300 flex-shrink-0" />
    </button>
  );
}
